// extracted by mini-css-extract-plugin
export default {"labelWithIcon":"vnPhNGI5zFsqV4kDg_x1"};